module.exports = __webpack_public_path__ + "img/user-card-bg.db4873c0.png";